import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a19d5c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "main-doc"
}
const _hoisted_2 = { id: "nav-bar" }
const _hoisted_3 = { id: "nav-ul" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  id: "nav-li"
}
const _hoisted_6 = {
  key: 1,
  id: "nav-li"
}
const _hoisted_7 = {
  key: 2,
  id: "nav-li"
}
const _hoisted_8 = {
  key: 1,
  id: "main-doc-mini"
}
const _hoisted_9 = { id: "nav-bar" }
const _hoisted_10 = { id: "home" }
const _hoisted_11 = {
  key: 0,
  id: "aboutme",
  style: {"min-height":"100vh"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "aboutme-title own-font" }, "Yusuf Kavalci", -1))
const _hoisted_14 = {
  key: 0,
  class: "own-font aboutme-subtitle"
}
const _hoisted_15 = {
  key: 1,
  class: "own-font aboutme-subtitle"
}
const _hoisted_16 = {
  key: 2,
  class: "own-font aboutme-subtitle"
}
const _hoisted_17 = {
  key: 0,
  class: "begining-text own-font"
}
const _hoisted_18 = {
  key: 1,
  class: "begining-text own-font"
}
const _hoisted_19 = {
  key: 2,
  class: "begining-text own-font"
}
const _hoisted_20 = {
  key: 0,
  class: "aboutme-title own-font"
}
const _hoisted_21 = {
  key: 1,
  class: "aboutme-title own-font"
}
const _hoisted_22 = {
  key: 2,
  class: "aboutme-title own-font"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = {
  key: 1,
  id: "aboutme",
  style: {"min-height":"100vh"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "aboutme-title own-font" }, "Yusuf Kavalci", -1))
const _hoisted_35 = {
  key: 0,
  class: "own-font aboutme-subtitle"
}
const _hoisted_36 = {
  key: 1,
  class: "own-font aboutme-subtitle"
}
const _hoisted_37 = {
  key: 2,
  class: "own-font aboutme-subtitle"
}
const _hoisted_38 = {
  key: 0,
  class: "begining-text own-font"
}
const _hoisted_39 = {
  key: 1,
  class: "begining-text own-font"
}
const _hoisted_40 = {
  key: 2,
  class: "begining-text own-font"
}
const _hoisted_41 = {
  key: 0,
  class: "aboutme-title own-font"
}
const _hoisted_42 = {
  key: 1,
  class: "aboutme-title own-font"
}
const _hoisted_43 = {
  key: 2,
  class: "aboutme-title own-font"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { id: "test" }
const _hoisted_54 = {
  id: "services",
  style: {"min-height":"100vh"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1))
const _hoisted_56 = {
  key: 0,
  class: "aboutme-title own-font"
}
const _hoisted_57 = {
  key: 1,
  class: "aboutme-title own-font"
}
const _hoisted_58 = {
  key: 2,
  class: "aboutme-title own-font"
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 0,
  class: "own-font aboutme-subtitle"
}
const _hoisted_61 = {
  key: 1,
  class: "own-font aboutme-subtitle"
}
const _hoisted_62 = {
  key: 2,
  class: "own-font aboutme-subtitle"
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 0,
  class: "own-font aboutme-subtitle"
}
const _hoisted_65 = {
  key: 1,
  class: "own-font aboutme-subtitle"
}
const _hoisted_66 = {
  key: 2,
  class: "own-font aboutme-subtitle"
}
const _hoisted_67 = {
  key: 3,
  class: "own-font aboutme-subtitle"
}
const _hoisted_68 = {
  key: 4,
  class: "own-font aboutme-subtitle"
}
const _hoisted_69 = {
  key: 5,
  class: "own-font aboutme-subtitle"
}
const _hoisted_70 = { class: "infos-aboutme" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { key: 2 }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { key: 2 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Feststellungserklärungen für Grundstücks- oder Erbengemeinschaften ", -1))
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { key: 2 }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { key: 2 }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { key: 2 }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { key: 2 }
const _hoisted_96 = { id: "test" }
const _hoisted_97 = {
  id: "contact",
  style: {"min-height":"100vh"}
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mapouter" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gmap_canvas" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      id: "gmap_canvas",
      src: "https://maps.google.com/maps?q=Steuerberatung%20Yusuf%20Kavalci&t=&z=13&ie=UTF8&iwloc=&output=embed",
      frameborder: "0",
      scrolling: "no",
      marginheight: "0",
      marginwidth: "0"
    }),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.embedgooglemap.net" })
  ])
], -1))
const _hoisted_100 = { key: 0 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "own-font contact-text" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Haberspirker Str. 32"),
  /*#__PURE__*/_createElementVNode("li", null, "86529 Schrobenhausen")
], -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "own-font contact-text" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Telefon: "),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:+4982529638812" }, "08252 / 9638812")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Mobil: "),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:+4917613697053" }, "0176 / 13697053")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Email: info@steuerberatung-kavalci.de")
], -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "own-font contact-text" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Montag bis Freitag 9 bis 17 Uhr"),
  /*#__PURE__*/_createElementVNode("li", null, "Samstag 9 bis 15 Uhr")
], -1))
const _hoisted_104 = { key: 1 }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "own-font contact-text" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Haberspirker Str. 32"),
  /*#__PURE__*/_createElementVNode("li", null, "86529 Schrobenhausen")
], -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "own-font contact-text" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Telefon: "),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:+4982529638812" }, "08252 / 9638812")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Mobil: "),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:+4917613697053" }, "0176 / 13697053")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Email: info@steuerberatung-kavalci.de")
], -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "own-font contact-text" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Montag bis Freitag 9 bis 17 Uhr"),
  /*#__PURE__*/_createElementVNode("li", null, "Samstag 9 bis 15 Uhr")
], -1))
const _hoisted_108 = { class: "bg-grey-lighten-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_parallax = _resolveComponent("v-parallax")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, {
      class: "mb-6",
      style: {"position":"fixed","top":"0","z-index":"9"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          justify: "end",
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: _ctx.logo,
                  cover: "",
                  class: "rounded-pill k-logo"
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        (!_ctx.isWidthSizeLower)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                              _createElementVNode("nav", _hoisted_2, [
                                _createVNode(_component_v_row, { align: "center" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      align: "center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          density: "compact",
                                          modelValue: _ctx.selectedLanguage,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
                                          items: ['DE', 'EN', 'TR'],
                                          variant: "outlined",
                                          class: "language-select"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "10" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("ul", _hoisted_3, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (nav) => {
                                            return (_openBlock(), _createElementBlock("a", {
                                              class: "nav-point",
                                              key: nav.link + '_id',
                                              onClick: ($event: any) => (_ctx.scrollIntoSection(nav.link))
                                            }, [
                                              (_ctx.selectedLanguage == 'DE')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                                                    _createVNode(_component_v_icon, {
                                                      icon: nav.icon
                                                    }, null, 8, ["icon"]),
                                                    _createTextVNode(" " + _toDisplayString(nav.title), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'EN')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                                    _createVNode(_component_v_icon, {
                                                      icon: nav.icon
                                                    }, null, 8, ["icon"]),
                                                    _createTextVNode(" " + _toDisplayString(nav.titleEN), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'TR')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                                                    _createVNode(_component_v_icon, {
                                                      icon: nav.icon
                                                    }, null, 8, ["icon"]),
                                                    _createTextVNode(" " + _toDisplayString(nav.titleTR), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 8, _hoisted_4))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createElementVNode("nav", _hoisted_9, [
                                _createVNode(_component_v_row, { align: "center" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "7",
                                      align: "center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          density: "compact",
                                          modelValue: _ctx.selectedLanguage,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
                                          items: ['DE', 'EN', 'TR'],
                                          variant: "outlined",
                                          class: "language-select"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "5" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_menu, null, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_app_bar_nav_icon, _normalizeProps(_guardReactiveProps(props)), null, 16)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (nav) => {
                                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                                    onClick: ($event: any) => (_ctx.scrollIntoSection(nav.link)),
                                                    key: nav.link + '_id'
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createBlock(_component_v_list_item_title, { key: 0 }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(nav.title), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createBlock(_component_v_list_item_title, { key: 1 }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(nav.titleEN), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createBlock(_component_v_list_item_title, { key: 2 }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(nav.titleTR), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_10, [
      _createVNode(_component_v_parallax, {
        height: "100vh",
        src: _ctx.homeImage
      }, null, 8, ["src"])
    ]),
    (!_ctx.isWidthSizeLower)
      ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                elevation: "16",
                                height: "80vh"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_img, {
                                    height: "80vh",
                                    cover: "",
                                    src: _ctx.aboutMeImage
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                elevation: "16",
                                style: {"min-height":"80vh"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, { elevation: "0" }, {
                                            title: _withCtx(() => [
                                              _hoisted_13
                                            ]),
                                            subtitle: _withCtx(() => [
                                              (_ctx.selectedLanguage == 'DE')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, "STEUERBERATER"))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'EN')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, "CERTIFIED TAX ADVISOR"))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'TR')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, "VERGİ DANIŞMANI"))
                                                : _createCommentVNode("", true)
                                            ]),
                                            text: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { align: "center" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Als Steuerberater ist es meine Leidenschaft, meinen Mandanten dabei zu helfen, Ihre steuerlichen Angelegenheiten zu optimieren und finanzielle Sicherheit zu erreichen. Mit einem individuellen Beratungsansatz und einem tiefen Verständnis für die komplexen Anforderungen des Steuerrechts stehe ich Ihnen zur Seite. "))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, " As a certified tax advisor, it is my passion to assist my clients in optimizing their tax matters and achieving financial security. With a personalized consulting approach and a deep understanding of the complex requirements of tax law, I am here to support you. "))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Vergi danışmanı olarak, müşterilerimin vergi işlerini optimize etmelerine ve finansal güvenliklerini sağlamalarına yardımcı olmak benim tutkum. Bireysel danışmanlık yaklaşımı ve vergi hukukunun karmaşık gereksinimlerine derin bir anlayışla size destek sağlıyorum. "))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider, { inset: "" }),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, { elevation: "0" }, {
                                            title: _withCtx(() => [
                                              (_ctx.selectedLanguage == 'DE')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Beruflicher Werdegang"))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'EN')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Professional Background"))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'TR')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_22, "İş Geçmişi"))
                                                : _createCommentVNode("", true)
                                            ]),
                                            text: _withCtx(() => [
                                              _createVNode(_component_v_list, {
                                                lines: "one",
                                                class: "own-font begining-text"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Studium der Betriebswirtschaftslehre an der OTH Amberg-Weiden"))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Study of Business Administration at OTH Amberg-Weiden."))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, "OTH Amberg-Weiden'de İşletme Yönetimi eğitimi."))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Steuerberater seit 2019 (Mitglied Steuerberaterkammer München)"))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Certified tax advisor since 2019 (Member of the Munich Chamber of Tax Consultants)."))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, "2019 yılından beri vergi danışmanıyım (Münih Vergi Danışmanları Odası üyesi)."))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, "Über 10 Jahre Berufserfahrung in einer der weltweit größten internationalen Wirtschaftsprüfungs- / Steuerberatungsgesellschaft („Big Four“)"))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, "Over 10 years of professional experience in one of the world's largest international auditing/tax consulting firms (\"Big Four\")."))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_31, "Dünyanın en büyük uluslararası denetim/vergi danışmanlık firmalarından birinde 10 yıldan fazla mesleki deneyime sahibim (\"Big Four\")."))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_32, [
          _hoisted_33,
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                elevation: "16",
                                height: "80vh"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_img, {
                                    height: "80vh",
                                    cover: "",
                                    src: _ctx.aboutMeImage
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                elevation: "16",
                                style: {"min-height":"80vh"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, { elevation: "0" }, {
                                            title: _withCtx(() => [
                                              _hoisted_34
                                            ]),
                                            subtitle: _withCtx(() => [
                                              (_ctx.selectedLanguage == 'DE')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_35, "STEUERBERATER"))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'EN')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, "CERTIFIED TAX ADVISOR"))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'TR')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_37, "YEMINLI MALI MÜŞAVIR"))
                                                : _createCommentVNode("", true)
                                            ]),
                                            text: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { align: "center" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_38, " Als Steuerberater ist es meine Leidenschaft, meinen Mandanten dabei zu helfen, ihre steuerlichen Angelegenheiten zu optimieren und finanzielle Sicherheit zu erreichen. Mit einem individuellen Beratungsansatz und einem tiefen Verständnis für die komplexen Anforderungen des Steuerrechts stehe ich Ihnen zur Seite. "))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_39, " As a certified tax advisor, it is my passion to assist my clients in optimizing their tax matters and achieving financial security. With a personalized consulting approach and a deep understanding of the complex requirements of tax law, I am here to support you. "))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_40, " Yeminli mali müşavir olarak, müşterilerimin vergi işlerini optimize etmelerine ve finansal güvenliklerini sağlamalarına yardımcı olmak benim tutkum. Bireysel danışmanlık yaklaşımı ve vergi hukukunun karmaşık gereksinimlerine derin bir anlayışla size destek sağlıyorum. "))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider, { inset: "" }),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, { elevation: "0" }, {
                                            title: _withCtx(() => [
                                              (_ctx.selectedLanguage == 'DE')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_41, "Beruflicher Werdegang"))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'EN')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_42, "Professional Background"))
                                                : _createCommentVNode("", true),
                                              (_ctx.selectedLanguage == 'TR')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_43, "İş Geçmişi"))
                                                : _createCommentVNode("", true)
                                            ]),
                                            text: _withCtx(() => [
                                              _createVNode(_component_v_list, {
                                                lines: "one",
                                                class: "own-font begining-text"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_44, "Studium der Betriebswirtschaftslehre an OTH Amberg-Weiden"))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_45, "Study of Business Administration at OTH Amberg-Weiden."))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_46, "OTH Amberg-Weiden'de İşletme Yönetimi eğitimi."))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_47, "Steuerberater seit 2019 (Mitglied Steuerberaterkammer München)"))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_48, "Tax consultant since 2019 (Member of the Munich Chamber of Tax Consultants)."))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_49, "2019 yılından beri vergi danışmanıyım (Münih Vergi Danışmanları Odası üyesi)."))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedLanguage == 'DE')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_50, "Über 10 Jahre Berufserfahrung in einer der weltweit größten internationalen Wirtschaftsprüfungs- / Steuerberatungsgesellschaft („Big Four“)"))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'EN')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_51, "Over 10 years of professional experience in one of the world's largest international auditing/tax consulting firms (\"Big Four\")."))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.selectedLanguage == 'TR')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_52, "Dünyanın en büyük uluslararası denetim/vergi danışmanlık firmalarından birinde 10 yıldan fazla mesleki deneyime sahibim (\"Big Four\")."))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])),
    _createElementVNode("section", _hoisted_53, [
      _createVNode(_component_v_parallax, {
        height: "50vh",
        src: _ctx.homeImage
      }, null, 8, ["src"])
    ]),
    _createElementVNode("section", _hoisted_54, [
      _hoisted_55,
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { justify: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { elevation: "16" }, {
                    title: _withCtx(() => [
                      (_ctx.selectedLanguage == 'DE')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_56, "Leistungen"))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLanguage == 'EN')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_57, "Services"))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLanguage == 'TR')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_58, "Hizmetler"))
                        : _createCommentVNode("", true)
                    ]),
                    subtitle: _withCtx(() => [
                      (!_ctx.isWidthSizeLower)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            (_ctx.selectedLanguage == 'DE')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_60, "PRIVATPERSONEN, ARBEITNEHMER, RENTNER und FREIBERUFLER"))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLanguage == 'EN')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_61, "INDIVIDUALS, EMPLOYEES, PENSIONERS and FREELANCERS"))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLanguage == 'TR')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_62, "BİREYLER, ÇALIŞANLAR, EMEKLİLER ve SERBEST ÇALIŞANLAR"))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            (_ctx.selectedLanguage == 'DE')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_64, "PRIVATPERSONEN, ARBEITNEHMER,"))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLanguage == 'DE')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_65, "RENTNER und FREIBERUFLER"))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLanguage == 'EN')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_66, "INDIVIDUALS, EMPLOYEES,"))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLanguage == 'EN')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_67, "PENSIONERS and FREELANCERS"))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLanguage == 'TR')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_68, "BİREYLER, ÇALIŞANLAR, "))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLanguage == 'TR')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_69, "EMEKLİLER ve SERBEST ÇALIŞANLAR"))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    text: _withCtx(() => [
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, {
                                  lines: "one",
                                  class: "own-font begining-text"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                      default: _withCtx(() => [
                                        (_ctx.selectedLanguage == 'DE')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_71, " Einkommensteuererklärungen mit Einkünften aus nichtselbständiger Arbeit, Kapitalvermögen, Vermietung und Verpachtung sowie sonstige Einkünfte z.B. aus Renten, Spekulationsgeschäften "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'EN')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_72, " Income tax returns with income from employment, capital assets, renting and leasing as well as other income, e.g. from pensions, speculative transactions "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'TR')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_73, " İstihdam, sermaye varlıkları, kiralamadan elde edilen gelirlerin yanı sıra emekli maaşları, spekülatif işlemler gibi diğer gelirleri içeren gelir vergisi beyannameleri "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.selectedLanguage == 'DE')
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 0,
                                          "prepend-icon": "mdi-chevron-right"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.selectedLanguage == 'DE')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_74, " Einnahmenüberschussrechnungen (EÜR) "))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.selectedLanguage == 'EN')
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 1,
                                          "prepend-icon": "mdi-chevron-right"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.selectedLanguage == 'EN')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_75, " Excess income statements (EÜR) "))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                      default: _withCtx(() => [
                                        (_ctx.selectedLanguage == 'DE')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_76, " Internationales Steuerrecht / Doppelbesteuerungsabkommen "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'EN')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_77, " International tax law / double taxation agreements "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'TR')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_78, " Uluslararası vergi hukuku / çifte vergilendirmeyi önleme anlaşmaları "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.selectedLanguage == 'DE')
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 2,
                                          "prepend-icon": "mdi-chevron-right"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_79
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.selectedLanguage == 'EN')
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 3,
                                          "prepend-icon": "mdi-chevron-right"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.selectedLanguage == 'EN')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_80, " Declarations of determination for real estate or communities of heirs "))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                      default: _withCtx(() => [
                                        (_ctx.selectedLanguage == 'DE')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_81, " Prüfung von Steuerbescheiden "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'EN')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_82, " Examination of tax assessments "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'TR')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_83, " Vergi değerlendirmelerinin incelenmesi "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                      default: _withCtx(() => [
                                        (_ctx.selectedLanguage == 'DE')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_84, " Durchführung von außergerichtlichen Rechtsbehelfen (z.B. Einsprüche) "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'EN')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_85, " Carrying out out-of-court legal remedies (e.g. objections) "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'TR')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_86, " Mahkeme dışı hukuki yolların kullanılması (örn. itirazlar) "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                      default: _withCtx(() => [
                                        (_ctx.selectedLanguage == 'DE')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_87, " Beratungen zur steuerlichen Gestaltung (z.B. Abfindungen) "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'EN')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_88, " Advice on tax planning (e.g. severance payments) "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'TR')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_89, " Vergi planlamasına ilişkin tavsiyeler (örneğin kıdem tazminatı ödemeleri) "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                      default: _withCtx(() => [
                                        (_ctx.selectedLanguage == 'DE')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_90, " Erstellung von steuerlichen Anträgen (z.B. Lohnsteuerermäßigung) "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'EN')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_91, " Preparation of tax applications (e.g. income tax reduction) "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'TR')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_92, " Vergi başvurularının hazırlanması (örn. gelir vergisi indirimi) "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item, { "prepend-icon": "mdi-chevron-right" }, {
                                      default: _withCtx(() => [
                                        (_ctx.selectedLanguage == 'DE')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_93, " Grundsteuerreform "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'EN')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_94, " Property tax reform "))
                                          : _createCommentVNode("", true),
                                        (_ctx.selectedLanguage == 'TR')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_95, " Mülkiyet vergisi reformu "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_96, [
      _createVNode(_component_v_parallax, {
        height: "50vh",
        src: _ctx.homeImage2,
        cover: ""
      }, null, 8, ["src"])
    ]),
    _createElementVNode("section", _hoisted_97, [
      _hoisted_98,
      _createVNode(_component_v_container, { class: "mb-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { elevation: "16" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _hoisted_99
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (!_ctx.isWidthSizeLower)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                    _createVNode(_component_v_row, { align: "start" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, { class: "pa-2 ma-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "ma-2 contact-icons",
                                  color: "rgba(36, 45, 57, 0.9)",
                                  icon: "mdi-map-marker-outline",
                                  variant: "text",
                                  size: "x-large"
                                }),
                                _hoisted_101
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, { class: "pa-2 ma-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "ma-2 contact-icons",
                                  color: "rgba(36, 45, 57, 0.9)",
                                  icon: "mdi-email-outline",
                                  variant: "text",
                                  size: "x-large"
                                }),
                                _hoisted_102
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, { class: "pa-2 ma-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "ma-2 contact-icons",
                                  color: "rgba(36, 45, 57, 0.9)",
                                  icon: "mdi-clock-outline",
                                  variant: "text",
                                  size: "x-large"
                                }),
                                _hoisted_103
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, { class: "pa-2 ma-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "ma-2 contact-icons",
                                  color: "rgba(36, 45, 57, 0.9)",
                                  icon: "mdi-map-marker-outline",
                                  variant: "text",
                                  size: "x-large"
                                }),
                                _hoisted_105
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, { class: "pa-2 ma-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "ma-2 contact-icons",
                                  color: "rgba(36, 45, 57, 0.9)",
                                  icon: "mdi-email-outline",
                                  variant: "text",
                                  size: "x-large"
                                }),
                                _hoisted_106
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, { class: "pa-2 ma-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "ma-2 contact-icons",
                                  color: "rgba(36, 45, 57, 0.9)",
                                  icon: "mdi-clock-outline",
                                  variant: "text",
                                  size: "x-large"
                                }),
                                _hoisted_107
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_108, [
      _createVNode(_component_v_row, {
        justify: "center",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
            return (_openBlock(), _createBlock(_component_v_btn, {
              key: link,
              class: "mx-2",
              rounded: "xl",
              variant: "text",
              onClick: ($event: any) => (_ctx.openInNewTab(link.link))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.title), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 64))
}